import * as VueRouter from "vue-router"
import CatalogView from "@/views/CatalogView.vue";

const routes = [
    {
        path: '/:page/',
        name: 'main',
        component: CatalogView
    },
    {
        path: '/:page/:cityCode/',
        name: 'cityView',
        component: CatalogView
    },
    {
        path: '/:page/:cityCode/:filter+',
        component: CatalogView
    },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
export const router = VueRouter.createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: VueRouter.createWebHistory(),
    routes, // short for `routes: routes`
})